import { formatMoneyForLocale } from '@stitch-fix/i18n';

export const formatProductImage = product => {
  return {
    alt: `${product.brand} - ${product.name}`,
    baseUrl: product.primaryImage?.baseUrl,
    mediaPath: product.primaryImage?.mediaPath,
    sizes: {
      sm: 320,
    },
  };
};

export const formatShopProductDetails = ({ locale, node }) => {
  const productDetails = {
    brand: node?.brand?.name,
    name: node?.name,
    price: formatMoneyForLocale(locale, node?.variantBySkuId?.price, {
      subunits: true,
    }),

    /*
     * Variant markdown values
     * Note: priceMarkdown will be null if there is no markdown
     */
    discountLabel: node?.variantBySkuId?.priceMarkdown?.discountLabel,
    fullPrice: formatMoneyForLocale(
      locale,
      node?.variantBySkuId?.priceMarkdown?.fullPrice ||
        node?.variantBySkuId?.price,
      { subunits: true },
    ),
  };

  return productDetails;
};

export const formatShopProductImage = node => {
  return {
    alt: `${node?.brand?.name} - ${node?.name}`,
    baseUrl: node?.variantBySkuId?.image?.baseUrl,
    mediaPath: node?.variantBySkuId?.image?.mediaPath,
    sizes: {
      sm: 320,
    },
  };
};
